import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class PhoneVerificationService {
  private apiGatewayUrl = environment.apiGatewayUrl;
  private checkExistsByPhoneUrl = `${this.apiGatewayUrl}onboarding-service/public/originations/check-exists/phone/{phoneNumber}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public existsByPhone(phoneNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<CustomResponseDto<boolean>>(this.checkExistsByPhoneUrl.replace('{phoneNumber}', phoneNumber), {
      headers: this.headers,
    });
  }
}
